<div *ngIf="editable; else previewMode">
  <div class="flex flex-col gap-4 mb-8">
    <div
      *ngIf="errorMessage"
      role="alert"
      class="rounded-xl border border-red-200 bg-red-50 p-3 text-sm font-medium text-red-700"
    >
      {{ errorMessage }}
    </div>

    <div
      *ngIf="successMessage"
      class="rounded-xl border border-emerald-200 bg-emerald-50 p-3 text-sm font-medium text-emerald-700"
    >
      {{ successMessage }}
    </div>

    <div>
      <h2 class="text-2xl font-semibold text-[#1E2A78]">
        {{ 'CREDIT_SECTION_FIN_PERF.SECTION_CONTENT' | translate }}
      </h2>

      <p class="text-sm text-gray-500 mt-1">
        {{ 'CREDIT_SECTION_FIN_PERF.SECTION_CONTENT_SUBTITLE' | translate }}
      </p>
    </div>

    <div class="flex flex-wrap gap-3">
      <button
        type="button"
        (click)="addHeading()"
        class="section-add-btn"
      >
        {{ 'CREDIT_SECTION_FIN_PERF.ADD_HEADING' | translate }}
      </button>

      <button
        type="button"
        (click)="addParagraph()"
        class="section-add-btn"
      >
        {{ 'CREDIT_SECTION_FIN_PERF.ADD_NARRATIVE' | translate }}
      </button>

      <button
        type="button"
        (click)="addBulletList()"
        class="section-add-btn"
      >
        {{ 'CREDIT_SECTION_FIN_PERF.ADD_BULLET_LIST' | translate }}
      </button>

      <button
        type="button"
        (click)="addTable()"
        class="section-add-btn"
      >
        {{ 'CREDIT_SECTION_FIN_PERF.ADD_TABLE' | translate }}
      </button>
    </div>
  </div>

  <div
    *ngIf="activeBlocks.length === 0"
    class="bg-gradient-to-r from-indigo-50 to-blue-50 border border-indigo-100 rounded-2xl p-10 text-center"
  >
    <h3 class="text-lg font-semibold text-[#1E2A78]">
      {{ 'CREDIT_SECTION_FIN_PERF.NO_CONTENT' | translate }}
    </h3>

    <p class="text-gray-500 mt-2">
      {{ 'CREDIT_SECTION_FIN_PERF.EMPTY_HINT' | translate }}
    </p>
  </div>

  <div class="space-y-5" cdkDropList (cdkDropListDropped)="onBlockDrop($event)">
    <div
      *ngFor="let block of activeBlocks; let blockIndex = index; trackBy: trackByBlock"
      cdkDrag
      cdkDragLockAxis="y"
      class="section-drag-item bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden"
    >
      <div
        (click)="block.expanded = !block.expanded"
        class="flex items-center justify-between gap-4 px-5 py-4 bg-gray-50 border-b cursor-pointer hover:bg-gray-100 transition"
      >
        <div class="flex items-center gap-4 min-w-0">
          <app-section-drag-handle cdkDragHandle (click)="$event.stopPropagation()"></app-section-drag-handle>

          <div
            class="w-11 h-11 shrink-0 rounded-xl bg-indigo-100 text-[#1E2A78] flex items-center justify-center font-semibold"
          >
            {{ blockIndex + 1 }}
          </div>

          <div class="min-w-0">
            <div class="flex flex-wrap gap-2">
              <span
                *ngIf="block.type === 'heading'"
                class="px-3 py-1 text-xs rounded-full bg-indigo-100 text-[#1E2A78]"
              >
                {{ 'CREDIT_SECTION_FIN_PERF.HEADING' | translate }}
              </span>

              <span
                *ngIf="block.type === 'paragraph'"
                class="px-3 py-1 text-xs rounded-full bg-blue-100 text-blue-700"
              >
                {{ 'CREDIT_SECTION_FIN_PERF.NARRATIVE' | translate }}
              </span>

              <span
                *ngIf="block.type === 'bullet-list'"
                class="px-3 py-1 text-xs rounded-full bg-green-100 text-green-700"
              >
                {{ 'CREDIT_SECTION_FIN_PERF.BULLET_LIST' | translate }}
              </span>

              <span
                *ngIf="block.type === 'table'"
                class="px-3 py-1 text-xs rounded-full bg-purple-100 text-purple-700"
              >
                {{ 'CREDIT_SECTION_FIN_PERF.TABLE' | translate }}
              </span>
            </div>

            <h3 class="font-semibold text-gray-800 mt-1 truncate">
              {{
                block.title ||
                  ((block.type === 'heading'
                    ? 'CREDIT_SECTION_FIN_PERF.UNTITLED_HEADING'
                    : block.type === 'paragraph'
                      ? 'CREDIT_SECTION_FIN_PERF.UNTITLED_NARRATIVE'
                      : block.type === 'bullet-list'
                        ? 'CREDIT_SECTION_FIN_PERF.UNTITLED_BULLET_LIST'
                        : 'CREDIT_SECTION_FIN_PERF.UNTITLED_TABLE') | translate)
              }}
            </h3>

            <p
              *ngIf="block.type === 'table' && block.table"
              class="text-xs text-gray-500 mt-1"
            >
              {{ 'CREDIT_SECTION_FIN_PERF.ROWS_COLS_SUMMARY' | translate: { rows: block.table.rows.length, cols: getLeafColumns(block).length } }}
            </p>
          </div>
        </div>

        <div class="flex items-center gap-3 shrink-0">
          <button
            type="button"
            (click)="requestRemoveBlock(blockIndex); $event.stopPropagation()"
            class="section-delete-btn"
          >
            {{ 'COMMON.DELETE' | translate }}
          </button>

          <span class="text-gray-500">
            {{ block.expanded ? '▲' : '▼' }}
          </span>
        </div>
      </div>

      <div *ngIf="block.expanded" class="p-6">
        <div *ngIf="block.type === 'heading'">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            {{ 'CREDIT_SECTION_FIN_PERF.HEADING_TEXT' | translate }}
          </label>

          <input
            [(ngModel)]="block.title"
            [placeholder]="'CREDIT_SECTION_FIN_PERF.HEADING_PLACEHOLDER' | translate"
            class="w-full h-12 px-4 border border-gray-300 rounded-xl outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500"
          />
        </div>

        <div *ngIf="block.type === 'paragraph'">
          <div class="mb-5">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              {{ 'CREDIT_SECTION_FIN_PERF.OPTIONAL_TITLE' | translate }}
            </label>

            <input
              [(ngModel)]="block.title"
              [placeholder]="'CREDIT_SECTION_FIN_PERF.NARRATIVE_TITLE_PLACEHOLDER' | translate"
              class="w-full h-12 px-4 border border-gray-300 rounded-xl outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500"
            />
          </div>

          <label class="block text-sm font-medium text-gray-700 mb-2">
            {{ 'CREDIT_SECTION_FIN_PERF.NARRATIVE_CONTENT' | translate }}
          </label>

          <app-rich-text-editor
            [(ngModel)]="block.content"
            minHeight="200px"
            [placeholder]="'CREDIT_SECTION_FIN_PERF.NARRATIVE_PLACEHOLDER' | translate"
          ></app-rich-text-editor>
        </div>

        <div *ngIf="block.type === 'bullet-list'">
          <div class="mb-5">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              {{ 'CREDIT_SECTION_FIN_PERF.OPTIONAL_TITLE' | translate }}
            </label>

            <input
              [(ngModel)]="block.title"
              [placeholder]="'CREDIT_SECTION_FIN_PERF.BULLET_TITLE_PLACEHOLDER' | translate"
              class="w-full h-12 px-4 border border-gray-300 rounded-xl outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500"
            />
          </div>

          <label class="block text-sm font-medium text-gray-700 mb-2">
            {{ 'CREDIT_SECTION_FIN_PERF.BULLET_ITEMS' | translate }}
          </label>

          <p class="text-xs text-gray-500 mb-3">
            {{ 'CREDIT_SECTION_FIN_PERF.ONE_ITEM_PER_LINE' | translate }}
          </p>

          <textarea
            [(ngModel)]="block.content"
            rows="10"
            [placeholder]="'CREDIT_SECTION_FIN_PERF.BULLET_ITEMS_PLACEHOLDER' | translate"
            class="w-full min-h-[240px] px-4 py-3 border border-gray-300 rounded-xl resize-y outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500"
          ></textarea>
        </div>

        <div *ngIf="block.type === 'table' && block.table">
          <div class="mb-5">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              {{ 'CREDIT_SECTION_FIN_PERF.TABLE_TITLE' | translate }}
            </label>

            <input
              [(ngModel)]="block.title"
              [placeholder]="'CREDIT_SECTION_FIN_PERF.TABLE_TITLE_PLACEHOLDER' | translate"
              class="w-full h-12 px-4 border border-gray-300 rounded-xl outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500"
            />
          </div>

          <div class="mb-5">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              {{ 'CREDIT_SECTION_FIN_PERF.TABLE_NOTE' | translate }}
            </label>

            <textarea
              [(ngModel)]="block.content"
              rows="3"
              [placeholder]="'CREDIT_SECTION_FIN_PERF.TABLE_NOTE_PLACEHOLDER' | translate"
              class="w-full px-4 py-3 border border-gray-300 rounded-xl resize-y outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500"
            ></textarea>
          </div>

          <div
            class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4"
          >
            <p class="text-sm text-gray-500">
              {{ 'CREDIT_SECTION_FIN_PERF.ROWS_HEADERS_COLS_SUMMARY' | translate: { rows: block.table.rows.length, headers: block.table.columns.length, cols: getLeafColumns(block).length } }}
            </p>

            <div class="flex flex-wrap gap-2">
              <button
                type="button"
                (click)="addHeader(block)"
                class="section-add-btn"
              >
                {{ 'CREDIT_SECTION_FIN_PERF.ADD_HEADER' | translate }}
              </button>

              <button
                type="button"
                (click)="addRow(block)"
                [disabled]="getLeafColumns(block).length === 0"
                class="section-add-btn"
              >
                {{ 'CREDIT_SECTION_FIN_PERF.ADD_ROW_PLUS' | translate }}
              </button>
            </div>
          </div>

          <div
            *ngIf="block.table.columns.length === 0"
            class="border border-dashed border-gray-300 rounded-xl p-7 text-center text-gray-500"
          >
            {{ 'CREDIT_SECTION_FIN_PERF.ADD_HEADER_FIRST' | translate }}
          </div>

          <div
            *ngIf="block.table.columns.length > 0"
            class="overflow-x-auto border border-gray-200 rounded-xl"
          >
            <table class="w-full min-w-[900px]">
              <thead>
                <tr>
                  <ng-container
                    *ngFor="let header of block.table.columns; let headerIndex = index; trackBy: trackByIndex"
                  >
                    <th
                      [attr.colspan]="getColumnLeafCount(header)"
                      [attr.rowspan]="getHeaderRowSpan(block, header)"
                      class="p-3 bg-[#1E2A78] min-w-[200px]"
                    >
                      <div class="flex gap-2 items-center">
                        <input
                          [(ngModel)]="header.title"
                          [placeholder]="'CREDIT_SECTION_FIN_PERF.HEADER_NAME' | translate"
                          class="w-full h-10 px-3 rounded-lg bg-white border border-transparent text-sm outline-none focus:ring-2 focus:ring-indigo-300"
                        />

                        <button
                          type="button"
                          (click)="addSubColumn(block, headerIndex)"
                          class="section-add-btn section-add-btn-sm"
                          [title]="'CREDIT_SECTION_FIN_PERF.ADD_SUB_COLUMN' | translate"
                        >
                          {{ 'CREDIT_SECTION_FIN_PERF.ADD_SUB' | translate }}
                        </button>

                        <button
                          type="button"
                          (click)="removeHeader(block, headerIndex)"
                          class="section-delete-btn section-delete-btn-sm"
                          [title]="'CREDIT_SECTION_FIN_PERF.DELETE_HEADER' | translate"
                        >
                          {{ 'COMMON.DELETE' | translate }}
                        </button>
                      </div>
                    </th>
                  </ng-container>

                  <th
                    [attr.rowspan]="hasAnySubColumns(block) ? 2 : 1"
                    class="bg-[#1E2A78] text-white text-sm w-28"
                  >
                    {{ 'COMMON.ACTION' | translate }}
                  </th>
                </tr>

                <tr *ngIf="hasAnySubColumns(block)">
                  <ng-container
                    *ngFor="let header of block.table.columns; let headerIndex = index; trackBy: trackByIndex"
                  >
                    <th
                      *ngFor="let subColumn of header.subColumns; let subIndex = index; trackBy: trackByIndex"
                      class="p-3 bg-[#26358f] min-w-[180px]"
                    >
                      <div class="flex gap-2 items-center">
                        <input
                          [(ngModel)]="header.subColumns[subIndex]"
                          [placeholder]="'CREDIT_SECTION_FIN_PERF.SUB_HEADER' | translate"
                          class="w-full h-10 px-3 rounded-lg bg-white border border-transparent text-sm outline-none focus:ring-2 focus:ring-indigo-300"
                        />

                        <button
                          type="button"
                          (click)="removeSubColumn(block, headerIndex, subIndex)"
                          class="section-delete-btn section-delete-btn-sm"
                          [title]="'CREDIT_SECTION_FIN_PERF.DELETE_SUB_HEADER' | translate"
                        >
                          {{ 'COMMON.DELETE' | translate }}
                        </button>
                      </div>
                    </th>
                  </ng-container>
                </tr>
              </thead>

              <tbody>
                <tr
                  *ngFor="let row of block.table.rows; let rowIndex = index; trackBy: trackByIndex"
                  class="border-b border-gray-100 hover:bg-gray-50"
                >
                  <td
                    *ngFor="let leaf of getLeafColumns(block); let colIndex = index; trackBy: trackByIndex"
                    class="p-3"
                  >
                    <input
                      [(ngModel)]="block.table.rows[rowIndex][colIndex]"
                      [placeholder]="'CREDIT_SECTION.ENTER_VALUE' | translate"
                      class="w-full h-10 px-3 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500"
                    />
                  </td>

                  <td class="p-3 text-center">
                    <button
                      type="button"
                      (click)="removeRow(block, rowIndex)"
                      class="section-delete-btn"
                    >
                      {{ 'COMMON.DELETE' | translate }}
                    </button>
                  </td>
                </tr>

                <tr *ngIf="block.table.rows.length === 0">
                  <td
                    [attr.colspan]="getLeafColumns(block).length + 1"
                    class="p-8 text-center text-gray-500"
                  >
                    {{ 'CREDIT_SECTION_FIN_PERF.NO_ROWS' | translate }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-popup
    [(show)]="showDeletePopup"
    title="CREDIT_SECTION_FIN_PERF.DELETE_BLOCK"
    type="confirm"
    [message]="deleteMessage"
    confirmText="COMMON.DELETE"
    cancelText="COMMON.CANCEL"
    (confirmed)="confirmRemoveBlock()"
  ></app-popup>
</div>

<ng-template #previewMode>
  <div
    *ngIf="activeBlocks.length === 0"
    class="bg-gray-50 border border-gray-200 rounded-2xl p-10 text-center text-gray-500"
  >
    {{ 'CREDIT_SECTION_FIN_PERF.NO_CONTENT_PREVIEW' | translate }}
  </div>

  <div *ngFor="let block of activeBlocks" class="mb-8">
    <h2
      *ngIf="block.type === 'heading'"
      class="text-2xl font-semibold text-[#1E2A78] border-b border-gray-200 pb-3"
    >
      {{ block.title }}
    </h2>

    <div *ngIf="block.type === 'paragraph'" class="text-gray-700">
      <h3
        *ngIf="block.title"
        class="text-lg font-semibold text-[#1E2A78] mb-3"
      >
        {{ block.title }}
      </h3>

      <div class="rich-text-content" [innerHTML]="block.content | richText"></div>
    </div>

    <div *ngIf="block.type === 'bullet-list'">
      <h3
        *ngIf="block.title"
        class="text-lg font-semibold text-[#1E2A78] mb-3"
      >
        {{ block.title }}
      </h3>

      <ul class="list-disc ps-6 space-y-2 text-gray-700">
        <li *ngFor="let line of getLines(block.content)">
          {{ line }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="block.type === 'table' && block.table && block.table.columns.length"
      class="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden"
    >
      <div *ngIf="block.title" class="px-6 py-4 border-b border-gray-200">
        <h3 class="text-xl font-semibold text-[#1E2A78]">
          {{ block.title }}
        </h3>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full min-w-[700px]">
          <thead>
            <tr class="bg-[#1E2A78] text-white">
              <ng-container *ngFor="let header of block.table.columns">
                <th
                  [attr.colspan]="getColumnLeafCount(header)"
                  [attr.rowspan]="getHeaderRowSpan(block, header)"
                  class="px-5 py-4 text-start text-sm font-semibold"
                >
                  {{ header.title || ('CREDIT_SECTION_FIN_PERF.UNTITLED_HEADER' | translate) }}
                </th>
              </ng-container>
            </tr>

            <tr
              *ngIf="hasAnySubColumns(block)"
              class="bg-[#26358f] text-white"
            >
              <ng-container *ngFor="let header of block.table.columns">
                <th
                  *ngFor="let subColumn of header.subColumns"
                  class="px-5 py-4 text-start text-sm font-semibold"
                >
                  {{ subColumn || ('CREDIT_SECTION_FIN_PERF.UNTITLED_SUB_HEADER' | translate) }}
                </th>
              </ng-container>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="let row of block.table.rows"
              class="border-b border-gray-100 last:border-b-0"
            >
              <td
                *ngFor="let cell of row; let cellIndex = index"
                class="px-5 py-4 text-sm text-gray-700"
                [class.text-end]="(cell | tableCell: block.table.columns : cellIndex).numeric"
                [class.tabular-nums]="(cell | tableCell: block.table.columns : cellIndex).numeric"
              >
                {{ (cell | tableCell: block.table.columns : cellIndex).text }}
              </td>
            </tr>

            <tr *ngIf="block.table.rows.length === 0">
              <td
                [attr.colspan]="getLeafColumns(block).length"
                class="px-5 py-8 text-center text-gray-500"
              >
                {{ 'CREDIT_SECTION_FIN_PERF.NO_DATA' | translate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        *ngIf="block.content"
        class="px-5 py-4 border-t border-gray-100 text-sm text-gray-600 whitespace-pre-line"
      >
        {{ block.content }}
      </div>
    </div>
  </div>
</ng-template>
